// extracted by mini-css-extract-plugin
export var contentWrapper = "embeddedContentGrid-module--content-wrapper--55766";
export var embeddedContent = "embeddedContentGrid-module--embedded-content--d6b61";
export var embeddedContentGrid = "embeddedContentGrid-module--embedded-content-grid--10e24";
export var flipsnack = "embeddedContentGrid-module--flipsnack--16c7c";
export var video = "embeddedContentGrid-module--video--14cc4";